import { FC } from 'react';
import styled from '@emotion/styled';
import { Icon, NakedButton, Text } from '@qga/roo-ui/components';
import { SelfServiceAPI as SelfServiceAPIType } from 'types';
import * as tracking from 'lib/gaTracking/bookingDetailsPageEvents';
import { SelfServiceAPI } from 'apis';
import { useDownloadInvoiceErrorModal } from '../../Alerts/Modal/DownloadInvoiceError';

const InlineFlexButton = styled(NakedButton)`
  display: inline-flex;
  align-items: center;
  font-weight: normal;
`;

const DownloadInvoiceButton: FC<{ booking: SelfServiceAPIType.Booking }> = ({ booking }) => {
  const openDownloadInvoiceErrorModal = useDownloadInvoiceErrorModal();
  if (booking.flags.isChangeInProgress) return null;

  const handleClick = async () => {
    tracking.downloadInvoiceLinkSelected('Charges');
    try {
      await SelfServiceAPI.downloadInvoicePdf(booking);
    } catch (e) {
      openDownloadInvoiceErrorModal();
    }
  };

  return (
    <InlineFlexButton color="brand.primary" aria-label="Download Tax Invoice Button" onClick={handleClick}>
      <Text fontSize="base">Download tax invoice (PDF)</Text>
      <Icon name="getApp" title="Download Tax Invoice" size={18} ml={1} />
    </InlineFlexButton>
  );
};

export default DownloadInvoiceButton;
